"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSmsQueue = exports.NotificationEmailQueue = exports.NotificationSummary = exports.Notification = exports.NotificationType = exports.NotificationSmsQueueStatus = exports.NotificationQueueStatus = exports.NotificationSendingType = exports.NotificationStatus = void 0;
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["None"] = "NONE";
    NotificationStatus["Wait"] = "WAIT";
    NotificationStatus["Preparing"] = "PREPARING";
    NotificationStatus["Prepared"] = "PREPARED";
    NotificationStatus["Broken"] = "BROKEN";
    NotificationStatus["NotProcessed"] = "NOT_PROCESSED";
    NotificationStatus["Done"] = "DONE";
    NotificationStatus["Failed"] = "FAILED";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
var NotificationSendingType;
(function (NotificationSendingType) {
    NotificationSendingType["Email"] = "EMAIL";
    NotificationSendingType["Sms"] = "SMS";
})(NotificationSendingType = exports.NotificationSendingType || (exports.NotificationSendingType = {}));
var NotificationQueueStatus;
(function (NotificationQueueStatus) {
    NotificationQueueStatus["Wait"] = "WAIT";
    NotificationQueueStatus["Sending"] = "SENDING";
    NotificationQueueStatus["Sent"] = "SENT";
    NotificationQueueStatus["Failed"] = "FAILED";
})(NotificationQueueStatus = exports.NotificationQueueStatus || (exports.NotificationQueueStatus = {}));
var NotificationSmsQueueStatus;
(function (NotificationSmsQueueStatus) {
    NotificationSmsQueueStatus["Wait"] = "WAIT";
    NotificationSmsQueueStatus["Processing"] = "PROCESSING";
    NotificationSmsQueueStatus["Requested"] = "REQUESTED";
    NotificationSmsQueueStatus["NotProcessed"] = "NOT_PROCESSED";
    NotificationSmsQueueStatus["Sent"] = "SENT";
    NotificationSmsQueueStatus["Failed"] = "FAILED";
})(NotificationSmsQueueStatus = exports.NotificationSmsQueueStatus || (exports.NotificationSmsQueueStatus = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["UserReg"] = "USER_REG";
    NotificationType["UserPasswordReset"] = "USER_PASSWORD_RESET";
    NotificationType["UserPasswordInit"] = "USER_PASSWORD_INIT";
    NotificationType["StudySubjectFirstReg"] = "STUDY_SUBJECT_FIRST_REG";
    NotificationType["StudySubjectFirstRegBulk"] = "STUDY_SUBJECT_FIRST_REG_BULK";
    NotificationType["StudySubjectFirstRegBySite"] = "STUDY_SUBJECT_FIRST_REG_BY_SITE";
    NotificationType["StudySubjectFirstRegBySiteBulk"] = "STUDY_SUBJECT_FIRST_REG_BY_SITE_BULK";
    NotificationType["StudySubjectReg"] = "STUDY_SUBJECT_REG";
    NotificationType["StudySubjectRegBulk"] = "STUDY_SUBJECT_REG_BULK";
    NotificationType["StudySubjectRandomNoAssign"] = "STUDY_SUBJECT_RANDOM_NO_ASSIGN";
    NotificationType["StudySubjectAllocationNoAssign"] = "STUDY_SUBJECT_ALLOCATION_NO_ASSIGN";
    NotificationType["StudySubjectUnblindReq"] = "STUDY_SUBJECT_UNBLIND_REQ";
    NotificationType["StudySubjectUnblinded"] = "STUDY_SUBJECT_UNBLINDED";
    NotificationType["StudySdvAutoRelease"] = "STUDY_SDV_AUTO_RELEASE";
    NotificationType["StudyEsignAutoRelease"] = "STUDY_ESIGN_AUTO_RELEASE";
    NotificationType["StudyReviewAutoRelease"] = "STUDY_REVIEW_AUTO_RELEASE";
    NotificationType["StudyUserReg"] = "STUDY_USER_REG";
    NotificationType["StudyTriggerEmail"] = "STUDY_TRIGGER_EMAIL";
    NotificationType["StudyTriggerSms"] = "STUDY_TRIGGER_SMS";
    NotificationType["StudyReportReg"] = "STUDY_REPORT_REG";
    NotificationType["StudyReportSub"] = "STUDY_REPORT_SUB";
    NotificationType["StudyReportSave"] = "STUDY_REPORT_SAVE";
    NotificationType["StudyFollowUpReportReg"] = "STUDY_FOLLOW_UP_REPORT_REG";
    NotificationType["StudyReportMappingDataChange"] = "STUDY_REPORT_MAPPING_DATA_CHANGE";
    NotificationType["StudyReportCancel"] = "STUDY_REPORT_CANCEL";
    NotificationType["StudyIpDeliveryReq"] = "STUDY_IP_DELIVERY_REQ";
    NotificationType["StudyIpDeliveryAutoReq"] = "STUDY_IP_DELIVERY_AUTO_REQ";
    NotificationType["StudyIpDeliveryAutoReqFail"] = "STUDY_IP_DELIVERY_AUTO_REQ_FAIL";
    NotificationType["StudyIpDeliveryCancel"] = "STUDY_IP_DELIVERY_CANCEL";
    NotificationType["StudyIpDeliveryApprove"] = "STUDY_IP_DELIVERY_APPROVE";
    NotificationType["StudyIpDeliveryStart"] = "STUDY_IP_DELIVERY_START";
    NotificationType["StudyIpDeliveryConfirm"] = "STUDY_IP_DELIVERY_CONFIRM";
    NotificationType["StudyIpDispense"] = "STUDY_IP_DISPENSE";
    NotificationType["StudyIpReturn"] = "STUDY_IP_RETURN";
    NotificationType["StudyIpReturnReq"] = "STUDY_IP_RETURN_REQ";
    NotificationType["StudyIpReturnConfirm"] = "STUDY_IP_RETURN_CONFIRM";
    NotificationType["StudyIpReturnCancel"] = "STUDY_IP_RETURN_CANCEL";
    NotificationType["StudyIpCraEsignAutoRelease"] = "STUDY_IP_CRA_ESIGN_AUTO_RELEASE";
    NotificationType["StudyIpCodeRetrieve"] = "STUDY_IP_CODE_RETRIEVE";
    NotificationType["StudyIpCodeAssign"] = "STUDY_IP_CODE_ASSIGN";
    NotificationType["StudyCustomDataCrfCreate"] = "STUDY_CUSTOM_DATA_CRF_CREATE";
    NotificationType["StudyScheduleEmailQuery"] = "STUDY_SCHEDULE_EMAIL_QUERY";
    NotificationType["StudyIndependentEvaluationFileUploaded"] = "STUDY_INDEPENDENT_EVALUATION_FILE_UPLOADED";
    NotificationType["StudyIndependentEvaluationFileReUploaded"] = "STUDY_INDEPENDENT_EVALUATION_FILE_REUPLOADED";
    NotificationType["StudyIndependentEvaluationCompleted"] = "STUDY_INDEPENDENT_EVALUATION_COMPLETED";
    NotificationType["StudyCustomTemplate"] = "STUDY_CUSTOM_TEMPLATE";
    NotificationType["StudySafetyIntegrationReg"] = "STUDY_SAFETY_INTEGRATION_REG";
    NotificationType["StudySafetyIntegrationCancel"] = "STUDY_SAFETY_INTEGRATION_CANCEL";
    NotificationType["StudySafetyIntegrationDataChanged"] = "STUDY_SAFETY_INTEGRATION_DATA_CHANGED";
    NotificationType["StudySafetyIntegrationIntg"] = "STUDY_SAFETY_INTEGRATION_INTG";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
class Notification {
}
exports.Notification = Notification;
class NotificationSummary {
}
exports.NotificationSummary = NotificationSummary;
class NotificationEmailQueue {
}
exports.NotificationEmailQueue = NotificationEmailQueue;
class NotificationSmsQueue {
}
exports.NotificationSmsQueue = NotificationSmsQueue;
//# sourceMappingURL=notification.js.map